import { z } from 'zod';
import { IsoDateTime } from './common.js';

/**
 * Lot BK : sauvegarde téléchargeable de la base (Réglages > Accueil, administrateurs). `GET /api/admin/backup`
 * renvoie le fichier lui-même (flux binaire, hors contrat JSON) ; `GET /api/admin/backup/last` dit qui a
 * téléchargé la dernière sauvegarde, et quand (lu dans le journal d'audit, action `backup.download`).
 */
export const BackupLastDownload = z.object({
  at: IsoDateTime,
  /** Nom du membre (null s'il a été supprimé depuis). */
  byName: z.string().nullable(),
  /** Taille du fichier, en octets. */
  bytes: z.int().min(0),
});
export type BackupLastDownload = z.infer<typeof BackupLastDownload>;

export const BackupInfo = z.object({ last: BackupLastDownload.nullable() });
export type BackupInfo = z.infer<typeof BackupInfo>;
